import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FileText } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import WidgetCard from '../components/WidgetCard';
import type { GeneratedDocument } from '../lib/types';

// The documents produced from the record: open the ones generated, see which
// others are ready to be.
export default function GeneratedDocuments() {
  const { authFetch } = useAuth();
  const [docs, setDocs] = useState<GeneratedDocument[] | null>(null);

  useEffect(() => {
    authFetch('/workspace/generated')
      .then(r => r.ok ? r.json() : [])
      .then(setDocs)
      .catch(() => setDocs([]));
  }, [authFetch]);

  if (!docs || docs.length === 0) return null;
  const generated = docs.filter(d => d.file_id);
  const ready = docs.filter(d => !d.file_id && d.ready);

  return (
    <WidgetCard
      title="Generated documents"
      icon={FileText}
      action={<Link to="/generated" className="text-[12px] text-brand-dark hover:underline">See all</Link>}
    >
      {generated.length > 0 ? (
        <ul className="divide-y divide-softgrey/60">
          {generated.map(d => (
            <li key={d.definition_id}>
              <Link to={`/files/${d.file_id}`} className="block py-2 text-[13px] text-graphite hover:text-brand-dark">
                {d.name}
              </Link>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-[13px] text-coolslate">Nothing generated yet.</p>
      )}
      {ready.length > 0 && (
        <p className="mt-2 text-[12px] text-coolslate">
          {ready.length === 1 ? '1 more document is' : `${ready.length} more documents are`} ready to generate.
        </p>
      )}
    </WidgetCard>
  );
}
